<template>
  <div :class="{'analytics-dashboard-value': true, 'highlight': highlight}">
    <div class="view-more" v-if="viewMoreLink">
      <router-link :to="viewMoreLink" target="_blank">View Details <i class="fas fa-chevron-right"></i></router-link>
    </div>
    <div class="title">
      <h4>{{title}}
        <Tooltip v-if="helpTip" :label="helpTip"><i class="far fa-info-circle"></i></Tooltip>
      </h4>
    </div>
    <div class="value">
      <h3><slot /></h3>
      <h5><slot name="info"></slot></h5>
    </div>
    <div class="info">
      <div :class="{'analytics-diff-badge': true, 'diff-positive': isPositiveDiff, 'diff-negative': isNegativeDiff, 'diff-same': isSameDiff}" v-if="hasDiff">
        <i :class="{'fas': true, 'fa-caret-up': isPositiveDiff, 'fa-caret-down': isNegativeDiff, 'fa-minus': isSameDiff}"></i> <span v-if="!isSameDiff">{{formatPercent(displayDiffPercent, 0, true)}}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.analytics-dashboard-value {
  position: relative;
  border: 1px solid #EFEFEF;
  border-radius: 15px;
  background-color: #FCFCFC;
  padding: 5px 8px;
  overflow: hidden;
}
.analytics-dashboard-value.highlight {
  border: 1px solid $general-highlight-color;
  background-color: $general-highlight-color;
}

.analytics-dashboard-value .title {
  min-height: 20px;
}
.analytics-dashboard-value .title h4 {
  color: #808080;
  font-size: 13px;
  font-weight: normal;
  text-align: left;
  margin-top: 3px;
  margin-bottom: 0;
}
.analytics-dashboard-value.highlight .title h4 {
  color: #FFFFFF;
}

.analytics-dashboard-value .value h3 {
  font-size: 24px;
  font-weight: bold;
  color: #707070;
  margin-bottom: 0.35rem;
  margin-top: 3px;
}
.analytics-dashboard-value.highlight .value h3 {
  color: #FFFFFF;
}
.analytics-dashboard-value .value h5 {
  font-size: 10px;
  color: #888888;
  margin-top: 0.15rem;
  margin-bottom: 6px;
}
.analytics-dashboard-value.highlight .value h5 {
  color: #FFFFFF;
}
.analytics-dashboard-value .info {
  position: absolute;
  top: 10px;
  right: 10px;
}
.analytics-dashboard-value .info .analytics-diff-badge {
  font-size: 11px;
}
.analytics-dashboard-value .info .analytics-diff-badge > i {
  font-size: 14px;
}
.analytics-dashboard-value .view-more {
  float: right;
  font-size: 12px;
  padding: 4px;
}
.analytics-dashboard-value.highlight .view-more a {
  color: #ffffff;
}
</style>

<script>
import Utils from '@/utils/utils'

export default {
  name: 'AnalyticsDashboardValue',
  props: {
    highlight: Boolean,
    title: String,
    value: Number,
    helpTip: String,
    previous: Number,
    viewMoreLink: String
  },
  computed: {
    diff() {
      return this.value - this.previous
    },
    hasDiff() {
      return this.previous !== undefined && this.value !== undefined
    },
    isPositiveDiff() {
      return this.diff >= 0.1
    },
    isNegativeDiff() {
      return this.diff <= -0.1
    },
    isSameDiff() {
      return !this.isPositiveDiff && !this.isNegativeDiff
    },
    displayDiffPercent() {
      if(this.previous == 0)
        return 100
      return Utils.roundNumber(Math.abs(1 - this.value / this.previous) * 100, 0)
    }
  }
}
</script>